import React from 'react'
import { View, Text } from 'react-native'
import { Doughnut } from 'react-chartjs-2';
import { BodyNormalDark } from '../TextStyles';
import { colors } from '../../const'
import localize from "../../localize";

export default function DoughnutChart({ data, title }) {

    let { character, life_experience, financial, health, my_xp } = data;
    character = (character || 0)
    life_experience = (life_experience || 0)
    financial = (financial || 0)
    health = (health || 0)

    let strength = character + life_experience + financial + health
    if (strength <= 0) return null

    const chartInit = {
        labels: [localize.character, localize.life_experience, localize.financial, localize.health_wellness],
        datasets: [{
            data: [character, life_experience, financial, health],
            backgroundColor: ['#00c221', '#5e23ff', '#ffd000', '#ff0048'],
            hoverBackgroundColor: ['#00c221', '#5e23ff', '#ffd000', '#ff0048']
        }]
    };

    return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            <Doughnut
                data={chartInit}
                height={200}
                options={{
                    cutoutPercentage: 70,
                    legend: false
                }}
            />
            <View style={{ flexDirection: 'column', position: "absolute", alignItems: 'center' }}>
                <Text style={{ color: colors.gray, fontSize: 13, fontWeight: 'bold', fontFamily: 'NotoSans-Regular' }}>
                    {title}
                </Text>
                <BodyNormalDark title={my_xp} />
            </View>
        </View>
    )

}